import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

type VerticalLinearStepperProps = {
  steps: Array<{ title: string; content: any }>;
  activeStep: number;
};

export default function VerticalLinearStepper({ steps, activeStep }: VerticalLinearStepperProps) {
  return (
    <Box sx={{ marginLeft: '120px' }}>
      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        sx={{
          '& .MuiStepLabel-label': {
            fontSize: '20px' // Make the label text bigger
          },
          '& .MuiStepIcon-root': {
            width: '20px', // Make the circle bigger
            height: '20px'
          },
          '& .MuiStepIcon-text': {
            fontSize: '14px' // Adjust the text inside the circle
          },
          '& .MuiStepConnector-root.MuiStepConnector-vertical': {
            marginLeft: '9px'
          },
          // Active step styling
          '& .Mui-active .MuiStepIcon-root': {
            border: '1px solid #009ED3', // Blue border
            color: '#FFFFFF', // Blue border color
            borderRadius: '50%', // Ensure it stays a circle
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          },
          '& .Mui-active .MuiStepIcon-text': {
            fill: '#009ED3' // Blue number color
          }
        }}
      >
        {steps.map((step, index) => (
          <Step id={`step-id-${step.title}`} key={step.title} expanded={index <= activeStep}>
            <StepLabel>{step.title}</StepLabel>
            <StepContent
              sx={{
                marginLeft: '9px',
                paddingLeft: '17px'
              }}
            >
              <Box>{step.content}</Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
